











import {
  computed,
  defineComponent,
  watch,
  onErrorCaptured
} from '@vue/composition-api';
import { provideStore, useStore } from '@/utils/use-store';
import AppDrawer from '@/components/AppDrawer.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import MessageBottomSheet from '@/components/MessageBottomSheet.vue';
import { EventBus } from '@/utils/EventBus';

export default defineComponent({
  name: 'App',

  components: {
    AppDrawer,
    AppNavbar,
    MessageBottomSheet
  },

  // not found needed implementation with composition API, that will be a part with vue2 code
  watch: {
    $route: function(to: any, from: any) {
      this.activePage = to.name || '';
    }
  },

  setup(props, { root: { $store, $router, $route } }) {
    provideStore($store);

    const store = useStore();
    let token: string | null = null;
    if (store.state.user) { token = store.state.user.accessToken; }

    const user = computed(() => store.state.user);
    watch(user, (user, oldUser) => {
      if (!oldUser && user) {
        $router.push('/');
      }
      if (!user && $route.name !== 'redeem') {
        $router.push('/login');
      }
    });

    const activePage = $route.name;
    // console.log(activePage.value);

    onErrorCaptured((err: Error) => {
      EventBus.$emit('openSheet', { open: true, color: 'error', message: err.message });
      if (err.message === 'Unauthorized') {
        store.dispatch('logout', user.value.id)
      }
      return false;
    });

    return {
      user,
      activePage
    };
  }
});
